
<div class="flex justify-content-center">
    <div class="image-container relative w-full h-15rem border-round shadow-2"
      [ngClass]="{ 'dragging': isDragging, 'border-red-500': venueImage }" (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave()" (drop)="onDrop($event)" (click)="fileInput.click()" (keydown.enter)="fileInput.click()">

      <div *ngIf="!selectedImage" class="placeholder flex align-items-center justify-content-center">
        <div class="text-center">
          <img src="../../../../assets/layout/images/ic_add_a_photo.svg" alt="Camera Icon" class="svg-icon mb-3" />
          <div class="font-semibold text-black-alpha-90">{{browseText}}</div>
          <div class="text-sm">Drop files here or click <u><a>browse</a></u> through your machine</div>

          <div class="text-sm text-red-500">Only SVG files are allowed.</div>
        </div>
      </div>

      <img *ngIf="selectedImage" [src]="selectedImage" class="w-full h-full border-round" alt="" />

      <div *ngIf="selectedImage" class="overlay flex flex-column align-items-center justify-content-center">
        <span>Drop files here or click to browse</span>
        @if(showRemove){
          <button class="p-button p-button-danger" (click)="removeFile($event)">Remove</button>
        }
      </div>

      <input #fileInput type="file" accept="image/svg+xml" class="hidden" (change)="onClickFileValidation($event)" />

    </div>

  </div>
  @if (venueImage) {
    <small class="p-error block">
      SVG is required.
    </small>
  }

  @if (errorMessage) {
    <small class="p-error block">
      {{ errorMessage }}
    </small>
  }
